import type { Stop } from 'core/domain/Stop'
import { formatCurrency } from 'core/utils/currency'
import { formatDate } from 'core/utils/date'

import type { Stop as ShipmentStop } from '../domain/Shipment'
import type { ShipmentChargeStatus, ShipmentChargeType } from '../domain/ShipmentCharges'

export function formatChargesDate(createdAt: string): string {
  const dateFormat = 'MMM, dd yyyy'
  return `${formatDate(new Date(createdAt), dateFormat)}`
}

export function formatChargeCurrency(value?: number) {
  return formatCurrency(value ?? 0, true)
}

export function formatStopName(stop: Stop | ShipmentStop | undefined): string {
  if (!stop) {
    return 'N/A'
  }
  if ('facilityName' in stop && stop.facilityName) {
    return stop.facilityName
  }
  if ('facility' in stop && stop.facility?.companyName) {
    return stop.facility.companyName
  }
  return [stop.address, stop.city, stop.state, stop.country].filter(Boolean).join(', ')
}

export function formatChargeTypeNameWithSuffix(chargeType: ShipmentChargeType): string {
  let suffix = ''

  if (
    chargeType.stopRelationship.includes('pickup') &&
    chargeType.stopRelationship.includes('delivery')
  ) {
    suffix = ' (Pickup & Delivery)'
  } else if (chargeType.stopRelationship.includes('pickup')) {
    suffix = ' (Pickup)'
  } else if (chargeType.stopRelationship.includes('delivery')) {
    suffix = ' (Delivery)'
  }

  return `${chargeType.name}${suffix}`
}

export function formatFileSize(bytes: number) {
  if (!bytes) {
    return '0 B'
  }

  const BYTES_PER_KILOBYTE = 1024
  const DECIMALS = 2
  const dm = Math.max(0, DECIMALS)
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

  const unit = Math.floor(Math.log(bytes) / Math.log(BYTES_PER_KILOBYTE))

  return `${parseFloat((bytes / Math.pow(BYTES_PER_KILOBYTE, unit)).toFixed(dm))} ${sizes[unit]}`
}

export function formatChargeShipperAction(status?: ShipmentChargeStatus) {
  if (status === 'approved') {
    return 'accepted'
  }
  if (status && ['rejected', 'canceled'].includes(status)) {
    return status
  }
  return ''
}
